export const MEDIA_QUERY_SM = '@media (max-width: 575px)'
export const MEDIA_QUERY_MD = '@media (max-width: 768px)'
export const MEDIA_QUERY_LG = '@media (max-width: 1280px)'